import { EventBus } from '@/event-bus.js'

const state = {
  curve01: 0,
  curve02: 0,
  curve03: 0,
  curve04: 0,
  u1: 0,
  v1: 0,
  u2: 0,
  v2: 0,
  u3: 0,
  v3: 0,
  force01: 0,
  force02: 0,
  force03: 0,
  selectedPt: -1,
  highlightedPt: -1,
  highlightedSlider: -1
}

const getters = {
  curve01: state => state.curve01,
  curve02: state => state.curve02,
  curve03: state => state.curve03,
  curve04: state => state.curve04,
  u1: state => state.u1,
  v1: state => state.v1,
  u2: state => state.u2,
  v2: state => state.v2,
  u3: state => state.u3,
  v3: state => state.v3,
  force01: state => state.force01,
  force02: state => state.force02,
  force03: state => state.force03,
  selectedPt: state => state.selectedPt,
  highlightedPt: state => state.highlightedPt,
  highlightedSlider: state => state.highlightedSlider
}

const mutations = {
  SET_SLIDERS (state, sliderValues) {
    state.curve01 = sliderValues[0]
    state.curve02 = sliderValues[1]
    state.curve03 = sliderValues[2]
    state.curve04 = sliderValues[3]
    EventBus.$emit('CurvesChanged')
  },
  SET_FORCES (state, sliderValues) {
    state.force01 = sliderValues[0]
    state.force02 = sliderValues[1]
    state.force03 = sliderValues[2]
    EventBus.$emit('ForcesChanged')
  },
  SET_UVS (state, uvs) {
    state.u1 = uvs[0]
    state.v1 = uvs[1]
    state.u2 = uvs[2]
    state.v2 = uvs[3]
    state.u3 = uvs[4]
    state.v3 = uvs[5]
    EventBus.$emit('PositionsChanged')
  },
  SET_SELECTED_PT (state, index) {
    state.selectedPt = index
  },
  SET_HIGHLIGHTED_PT (state, index) {
    if (state.selectedPt === -1) {
      state.highlightedPt = index
      EventBus.$emit('PtHighlighted', index)
    }
  },
  SET_HIGHLIGHTED_SLIDER (state, index) {
    state.highlightedSlider = index
  }
}

const actions = {
  SetSliders ({
    commit
  }, sliderValues) {
    commit('SET_SLIDERS', sliderValues)
  },
  SetForces ({
    commit
  }, sliderValues) {
    commit('SET_FORCES', sliderValues)
  },
  SetSelectedPt ({
    commit
  }, index) {
    commit('SET_SELECTED_PT', index)
  },
  SetHighlightedPt ({
    commit
  }, index) {
    commit('SET_HIGHLIGHTED_PT', index)
  },
  SetHighlightedSlider ({
    commit
  }, index) {
    commit('SET_HIGHLIGHTED_SLIDER', index)
  },
  SetUVs ({
    commit
  }, uvs) {
    commit('SET_UVS', uvs)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
